import React, {Component} from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import Select from 'react-select';
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import 'bootstrap-daterangepicker/daterangepicker.css';
import Picker from 'react-month-picker'
import MonthBox from "views/MonthBox.jsx";
import "../../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {BeatLoader} from 'react-spinners';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {connect}  from  "react-redux";

const override = css `
  display: block;
  margin: 0 auto;
  border-color: red;
  text-align:center
`;
var download_count = 0;
var timestamp  = new Date().getTime();
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};
var year = new Date().getFullYear();
var mo = new Date().getMonth();
var month_val = '';
if(mo.toString().length==1){
    month_val = "" +0+mo;
}
else {
    month_val = mo;
}
function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
let dateDefault = new Date();
let monthd = dateDefault.setMonth(dateDefault.getMonth() -1);
dateDefault = dateDefault.toDateString();
dateDefault = new Date(dateDefault);
let monthDefaults = getMonth(dateDefault);
let yearDefault= dateDefault.getFullYear();

const months = new Array("01", "02", "03", "04", "05", "06",
    "07", "08", "09", "10", "11", "12"
);
var timestamp = new Date().getTime();
var monthOptions = [];
var monthName = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
var d = new Date();
d.setDate(1);
var curr_yr = d.getFullYear();
var prevMonth = monthName[d.getMonth()-1]
for (var i=0; i<=23; i++) {
    //console.log(months[d.getMonth()]+d.getFullYear());
    monthOptions.push({ value: months[d.getMonth()]+d.getFullYear(), label: monthName[d.getMonth()] + ' ' +d.getFullYear() })
    d.setMonth(d.getMonth() - 1);
}

var month_years = "" +monthDefaults+yearDefault;

class FlatFiles extends Component{
    constructor(props) {
        super(props);
        this.state ={
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            mvalue: {year: yearDefault, month: monthDefaults},
            m_yr: [month_years],
            transactionType:["All"],
            tra_cat_list:[],
            _notificationSystem: null,
            btids:'',
            utids:'',
            is_chain_loading: true,
            is_merchant_loading: true,
            is_store_loading: true,
            download_count:1,
            total_count:'',
            show_count: false,
            dw_msg: "Downloading",
            monthValue: [{ value: month_years, label: prevMonth+" "+curr_yr}],
            monthsLists:monthOptions,
            traValue:[]
        }
        this.handleClickMonthBox = this.handleClickMonthBox.bind(this);
        this.handleAMonthChange = this.handleAMonthChange.bind(this);
        this.handleAMonthDissmis = this.handleAMonthDissmis.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this.subMenuPermission();
        this.get_transaction_category();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });



        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this._getAllMerchants();
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Merchant') {
            this.get_merchant_by_object_code(arrayCode, 'merchant');
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode);
            var merchant_list_box = false;
            var objID = arrayCode[0];
            if (arrayCode.length > 1) {
                merchant_list_box = true;
                objID = '';
            }
            this.setState({
                merchant_list_box: merchant_list_box,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                merchantID: objID

            })
        }
        else if(decoded.object_type=='Chain') {

            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode);
            this.get_merchant_by_object_code(arrayCode, 'chain');
            var chain_list_box = false;
            var objID = arrayCode;
            if (arrayCode.length > 1) {

                this.get_chain_by_object_code(arrayCode, 'chain');
                chain_list_box = true;
                objID = '';
            }

            this.setState({
                merchant_list_box: false,
                chain_list_box: chain_list_box,
                store_list_box: true,
                acq_bank_list_box: true,
                chainID: objID
            })
        }
        else if(decoded.object_type=='Store') {
            this.get_merchant_by_object_code(arrayCode, 'store');
            this.get_chain_by_object_code(arrayCode, 'store');

            var store_list_box = false;
            var objID = arrayCode;
            if (arrayCode.length > 1) {

                this.get_store_by_object_code(arrayCode, 'store');
                store_list_box = true;
                objID = '';
            }
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: store_list_box,
                acq_bank_list_box: true,
                storeID: objID
            })
        }


        else {
            this.unauthorize_access();
        }

    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("flat_files")===false){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    get_transaction_category(){
        axios.get(config.get('API_URL')+'/reports/get-tra-category-test/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                this.setState({
                    tra_cat_list:response.data
                })
            }
        });
    }
    changeMonth(optionSelected) {
        let value='';
        let mArray = [];
        if(optionSelected.length<1){
            value = null;
            mArray = '';
        }
        else{
            optionSelected.map((months, i) => {
                mArray.push(months.value)

                var index = this.state.monthsLists.findIndex(obj => obj.value == months.value);
                this.state.monthsLists.move(index, 0).join(',');

            });
        }
        this.setState({
            m_yr: mArray,
            monthValue:optionSelected,
        });
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }
        });
    }

    // logged_Merchant(login_type, optionSelected) {
    //     let value = '';
    //     let midArray = [];
    //     if (optionSelected.length < 1) {
    //         value = null;
    //         midArray = '';
    //     } else {
    //         optionSelected.map((mids, i) => {
    //             midArray.push(mids.value)
    //             if (login_type != 'merchant') {
    //                 var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
    //                 this.state.merchantList.move(index, 0).join(',');
    //             }
    //         });
    //     }
    //     this.setState({
    //         merchantID: midArray,
    //         chainID: '',
    //         merchantValue: optionSelected,
    //         chainValue: [],
    //         storeID: '',
    //         storeValue: []
    //     });
    //
    //     if (login_type == '') {
    //         this.getChain(value, 'merchant', this.state.object_type, this.state.object_code);
    //         this.getStore(value, 'merchant', this.state.object_type, this.state.object_code);
    //     }
    //
    // }

    changeMerchant(login_type, optionSelected){
        //const value = optionSelected === null ? '' : optionSelected.value;
        let value = '';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.merchantList.findIndex(obj => obj.value==mids.value);
                this.state.merchantList.move(index,0).join(',');
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: []
        });
        if (this.state.object_type == 'Chain') {
            this.get_chain_by_login(this.state.object_code, midArray, 'chain');
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);

        } else if (this.state.object_type == 'Store') {
            this.get_chain_by_login(this.state.object_code, midArray, 'store');
            this.get_store_by_login(this.state.object_code, midArray, 'store');

        } else {
            if (login_type == '') {
                this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
                this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
            }
        }


    }

    changeChain(login_type, optionSelected) {
        //const value = optionSelected === null ? '' : optionSelected.value;
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value == cids.value);
                    this.state.chainList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: ''
        });

        if (this.state.object_type == 'Store') {
            this.get_store_by_login(this.state.object_code, cidArray, 'chain');
        } else {
            if (login_type == '') {
                this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
            }
        }

        //this.get_merchant_by_chain(cidArray);
    }

    get_merchant_by_chain(cidArray) {
        var midArray = []
        axios.post(config.get('API_URL') + '/reports/get-merchant-by-chains/', {
                chains: cidArray
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            response.data.map((value, index) => {
                midArray.push(value.merchant_code)
            })

            this.setState({
                merchantID: midArray
            })
        });
    }

    get_merchant_by_object_code(object_codes, type) {
        var midArray = []
        axios.post(config.get('API_URL') + '/reports/get-merchant-by-object-codes/', {
                object_codes: object_codes,
                type: type
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
                if (response.data.length > 1) {
                    this.setState({
                        merchant_list_box: true,
                    })
                } else {
                    this.setState({
                        merchantID: [response.data[0].merchant_code]
                    })
                }
                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
            this.setState({
                is_merchant_loading: false
            })
        });

    }

    get_chain_by_object_code(object_codes, type) {
        var chArray = []
        axios.post(config.get('API_URL') + '/reports/get-chain-by-object-codes/', {
                object_codes: object_codes,
                type: type
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID: ''});
            if (response.data.length > 1) {
                this.setState({
                    chain_list_box: true,
                })
            } else {
                chArray.push(response.data[0].chain_code)
                this.setState({
                    chainID: chArray
                })
            }
            response.data.map((chain, index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList: chalinList,
                is_chain_loading: false
            })
        });

    }

    get_store_by_object_code(object_codes, type) {
        var midArray = []
        axios.post(config.get('API_URL') + '/reports/get-store-by-object-codes/', {
                object_codes: object_codes,
                type: type
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let storeList = [];
            this.setState({storeID: ''});
            response.data.map((store, index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList: storeList,
                is_store_loading: false
            })
        });

    }

    get_chain_by_login(object_codes, mcode, type) {
        var midArray = []
        axios.post(config.get('API_URL') + '/reports/get-chain-by-login/', {
                object_codes: object_codes,
                type: type,
                mcode: mcode,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID: ''});
            response.data.map((chain, index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList: chalinList,
                is_chain_loading: false
            })
        });

    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/reports/get-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }

    changeStore(login_type, optionSelected) {
        //const value = optionSelected === null ? '' : optionSelected.value;
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                if (login_type != 'store') {
                    var index = this.state.storeList.findIndex(obj => obj.value == sids.value);
                    this.state.storeList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        //this.get_merchant_by_store(sidArray)
    }

    get_store_by_login(object_codes, mcode, type) {
        var midArray = []
        axios.post(config.get('API_URL') + '/reports/get-store-by-login/', {
                object_codes: object_codes,
                type: type,
                mcode: mcode,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let storeList = [];
            this.setState({storeID: ''});
            response.data.map((store, index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList: storeList,
                is_store_loading: false
            })
        });

    }

    get_merchant_by_store(sidArray) {
        var midArray = [];
        axios.post(config.get('API_URL') + '/reports/get-merchant-by-stores/', {
                stores: sidArray
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            response.data.map((value, index) => {
                midArray.push(value.merchant_code)
            })

            this.setState({
                merchantID: midArray
            })
        });
    }
    changeUtids(e){
        this.setState({utids:e.target.value})
    }

    changeBtids(e){
        this.setState({btids:e.target.value})
    }
    flatFilesReportDownload (e){
        this.setState({
            download_count: 1,
            total_count: '',
            show_count: false,
            dw_msg: "Downloading"
        })
        var btidArry =[];
        var utidArry =[];
        download_count = 0;

        if(this.state.merchantID==''){
            this.handleNotificationClick("tr", 3, "Please Select Merchant.");
            return false;
        }
        if(this.state.m_yr.length>1 && this.state.merchantID.length>1){
            this.handleNotificationClick("tr", 3, "Please Select multiple months for same merchant");
            return false;
        }
        if(this.state.m_yr.length>12){
            this.handleNotificationClick("tr", 3, "Please Select 12 months at a time");
            return false;
        }
        if(this.state.merchantID.length>10){
            this.handleNotificationClick("tr", 3, "Please Select 10 months at a time");
            return false;
        }
        var utid_str = this.state.utids;
        if(utid_str!='') {
            var utidErr = ''
            utid_str = utid_str.replace(/\s*,\s*/g, ",");
            utidArry = utid_str.split(",");
            utidArry.map((utid, index) => {
                if(utid.length!=8){
                    utidErr = 'error'
                }
            });
            if(utidErr=='error'){
                this.handleNotificationClick("tr", 3, "Invalid UTID");
                return false
            }
            //console.log(utidArry);
        }

        var btid_str = this.state.btids;

        if(btid_str!='') {
            btid_str = btid_str.replace(/\s*,\s*/g, ",");
            var btidErr = ''
            btidArry = btid_str.split(",");
            btidArry.map((btid, index) => {
                if(btid.length!=8){
                    btidErr = 'error'

                }
            });
            if(btidErr=='error'){
                this.handleNotificationClick("tr", 3, "Invalid BTID");
                return false
            }
            //console.log(btidArry);
        }
        if(utidArry.length==0){
            utidArry = "";
        }
        if(btidArry.length==0){
            btidArry = "";
        }
        this.setState({
            loading: true,
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        let storeFilter = this.state.storeID;
        if(this.state.object_type==='Store' && this.state.storeID==''){
            storeFilter = this.state.object_code;
        }
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: storeFilter,
            month: this.state.m_yr,
            user_id: this.state.user_id,
            utids: utidArry,
            btids: btidArry,
            transaction_type: this.state.transactionType
        };
        //console.log(postData);
        let xhrBank = $.ajax({
            url:config.get('API_URL') + "/reports/file-names-test/",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },

            success: function (response, status, xhr) {


                if(Array.isArray(response.data) && response.data.length) {
                    if(response.data[0].length<1){
                        this.handleNotificationClick("tr", 3, "No data present for given merchant for given month");
                        this.setState({
                            loading: false,
                            is_download: true,
                        })
                        return false
                    }
                    this.setState({
                        total_count:response.data.length,
                        show_count: true
                    })
                    response.data.map((path, index) => {
                        // list.map((files, index) => { console.log(files)
                        //     this.downloadFiles(files.path, index, utidArry, btidArry )
                        // });
                        this.downloadFiles(path, index, utidArry, btidArry )
                    });

                } else {
                    this.handleNotificationClick("tr", 3, "No data present for given merchant for given month");
                    this.setState({
                        loading: false,
                        is_download: true,
                    })
                }
            }.bind(this),
            error: function (jqXHR, exception) {
                this.handleNotificationClick("tr", 3, "No data present for given merchant for given month");
                this.setState({
                    loading: false,
                    is_download: true,
                })
            }.bind(this),
        });
        this.setState({
            xhrBank: xhrBank
        })

    }

    downloadFiles(data, index, utidArry, btidArry){
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            month: this.state.m_yr,
            user_id: this.state.user_id,
            utids: utidArry,
            btids: btidArry,
            file_key: data,
            transaction_type: this.state.transactionType
        };
        var fname = data[0].path.split("/");
        console.log("hgdhfg");
        console.log(data);

        let xhrBank = $.ajax({
            url:config.get('API_URL') + "/reports/flat-files-download/",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                var res = typeof response
                //console.log(response);

                if(res==='object') {
                    let blob = new Blob([response], {
                        type: "octet/stream"
                    });
                    let fileName = timestamp+'_'+'_'+fname[6]+'_'+this.state.m_yr+'-'+this.state.user_id+'-'+index+'.csv.gz';
                    let rfile = fileName.replace(/\"/g, "");
                    let a = document.createElement('a');
                    let url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = rfile;
                    a.click();
                    window.URL.revokeObjectURL(url);
                } else{
                    this.handleNotificationClick("tr", 3, "No data present for given merchant for given month");
                }
                download_count++;
                if(download_count===this.state.total_count){
                    this.setState({
                        dw_msg: "Downloaded"
                    })
                }
                this.setState({
                    loading: false,
                    is_download: true,
                    download_count:download_count
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })
    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    handleClickMonthBox (e) {
        this.refs.pickAMonth.show()
    }
    handleAMonthChange(value, text) {
        var month = '';
        if(text.toString().length==1){
            month = "" +0+text;
        }
        else {
            month = text;
        }

        var month_year = "" +month+value;
        this.setState({
            m_yr: month_year,
            mvalue: {year: value, month: text}
        });
        //this.refs.pickAMonth.hide()
        this.handleAMonthDissmis(this.state.mvalue);
    }
    handleAMonthDissmis(value) {
        // this.setState({
        //     mvalue: value
        // });
    }

    changeTransactionType(e){
        //if(e.target.value=='All' || e.target.value=='All Successful'){
            this.setState({
                transactionType: [e.target.value]
            })
        // }
        // else{
        //     this.setState({
        //         transactionType: ['All']
        //     })

        //     this.handleNotificationClick("tr", 3, "Transaction Type not supported");

        // }

    }
    render() { //console.log(this.state.transactionType); console.log(this.state.merchantID);
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', to: 'To',
        };

        const mvalue = this.state.mvalue
        ;
        const makeText = m => {
            if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year);
            return '?'
        };
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "30px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "34px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        let category = this.state.tra_cat_list.map((cat, index) =>{
            return (
                <option value={cat.transaction_category_name} key={index+1}>{cat.transaction_category_display_name}</option>
            )
        });
        return(

            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-report-history">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Transaction Report History</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="">
                                        <div className="col-md-2  col-xs-12">
                                            <div className="form-group file-m-p">
                                                {/*<label htmlFor="queryName" className="">Select Month</label>*/}
                                                {/*<Picker*/}
                                                {/*    ref="pickAMonth"*/}
                                                {/*    theme="light"*/}
                                                {/*    years={{*/}
                                                {/*        max: {*/}
                                                {/*            year: new Date().getFullYear(),*/}
                                                {/*            month: new Date().getMonth()*/}
                                                {/*        },*/}
                                                {/*        min: {year: 2019, month: 4}*/}
                                                {/*    }}*/}
                                                {/*    // years={new Date().getFullYear()}*/}
                                                {/*    value={mvalue}*/}
                                                {/*    lang={pickerLang.months}*/}
                                                {/*    onChange={this.handleAMonthChange}*/}
                                                {/*    onDismiss={this.handleAMonthDissmis}*/}
                                                {/*>*/}
                                                {/*    <MonthBox value={makeText(mvalue)} onClick={this.handleClickMonthBox} />*/}
                                                {/*</Picker>*/}
                                                <label > Month </label>
                                                <ReactMultiSelectCheckboxes name="month"
                                                                            value={this.state.monthValue}
                                                                            styles={customStyles} className="chainLists"
                                                                            isClearable={false}
                                                                            onChange={this.changeMonth.bind(this)}
                                                                            options={this.state.monthsLists}
                                                                            placeholderButtonLabel="Months"
                                                />
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 date-icon-small">

                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">Transaction Type</label>
                                                <select name="transctionType" className="form-control tr-history-opt" value={this.state.transactionType} onChange={this.changeTransactionType.bind(this)}>
                                                    {category}
                                                </select>
                                            </div>
                                        </div>
                                        {this.state.merchant_list_box ===true?
                                            <div className="col-md-2 filter-bottom5 ">
                                                <label>Merchants</label>
                                                <ReactMultiSelectCheckboxes name="merchants"
                                                    // isMulti
                                                                            isLoading={this.state.is_merchant_loading}
                                                                            value={this.state.merchantValue}
                                                                            styles={customStyles} className="report-listbox"
                                                                            isClearable={false}
                                                                            onChange={this.changeMerchant.bind(this,'')}
                                                                            options={this.state.merchantList}
                                                                            placeholderButtonLabel ="Select [Merchant]"
                                                />

                                                <div className="clearfix"></div>
                                            </div> : null}
                                        {this.state.chain_list_box===true?
                                            <div className="col-md-2 filter-bottom5 ">
                                                <label> Chain </label>
                                                <ReactMultiSelectCheckboxes name="chain"
                                                                            isMulti
                                                                            isLoading={this.state.is_chain_loading}
                                                                            components={{ MenuList }}
                                                                            value={this.state.chainValue}
                                                                            styles={customStyles} className="report-listbox"
                                                                            isClearable={false}
                                                                            onChange={this.changeChain.bind(this,'')}
                                                                            options={this.state.chainList}
                                                                            placeholderButtonLabel="Select [Chain]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>: null }
                                        {this.state.store_list_box===true?
                                            <div className="col-md-2 filter-bottom5 ">
                                                <label> Store </label>
                                                <ReactMultiSelectCheckboxes name="store"
                                                                            isMulti
                                                                            isLoading={this.state.is_store_loading}
                                                                            components={{ MenuList }}
                                                                            value={this.state.storeValue}
                                                                            styles={customStyles} className="report-listbox"
                                                                            isClearable={false}
                                                                            onChange={this.changeStore.bind(this, '')}
                                                                            options={this.state.storeList}
                                                                            placeholderButtonLabel="Select [Store]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>: null }


                                    </div>
                                    <div className="clearfix"></div>
                                    <div>
                                        <div className="col-md-6 filter-bottom5 ">
                                            <label> UTIDs (Comma-separated values) </label>
                                            <textarea name = "utids" rows="3" placeholder="" id="formControlsTextarea" onChange={this.changeUtids.bind(this)}
                                                      className="form-control pricingDescription" value={this.state.utids}>
                                        </textarea>
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-6 filter-bottom5 ">
                                            <label> BTIDs (Comma-separated values) </label>
                                            <textarea name = "btids" rows="3" placeholder="" id="formControlsTextarea" onChange={this.changeBtids.bind(this)}
                                                      className="form-control pricingDescription" value={this.state.btids}>
                                        </textarea>
                                            <div className="clearfix"></div>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="">
                                        <div className="col-md-6">


                                            <Button color="primary" onClick={this.flatFilesReportDownload.bind(this)}
                                                    disabled={this.state.merchantID == ''}>Submit</Button>
                                            {this.state.merchantID == '' ?
                                                <span className="note-italic">Please Select Merchant</span> : null}


                                        </div>
                                        <div className="col-md-6 pull-right">
                                            {this.state.show_count===true?
                                                <div>{this.state.dw_msg} {this.state.download_count}  of {this.state.total_count} reports</div>:null
                                            }
                                        </div>
                                    </div>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={15}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />


                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(FlatFiles);